<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t, tm } = useI18n()

interface Offer {
  image: string;
  title: string;
  description: string;
  buttonText: string;
  formValue: string;
}

const offers = tm('offerSection.offers') as Offer[]

// Function to handle button click
const handleButtonClick = (formValue: string) => {
  // Find the form section
  const formSection = document.getElementById('contact');
  if (formSection) {
    // Smooth scroll to form section
    formSection.scrollIntoView({ behavior: 'smooth' });
    
    // Set a small timeout to ensure the select element is available after scrolling
    setTimeout(() => {
      // Set the select value
      const selectElement = document.getElementById('Subject') as HTMLSelectElement;
      if (selectElement) {
        selectElement.value = formValue;
        // Trigger change event to ensure v-model updates
        selectElement.dispatchEvent(new Event('change'));
      }
    }, 100);
  }
};
</script>

<template>
  <section class="py-16 bg-[#16A7FF] relative overflow-hidden">
    <div 
      class="absolute inset-0"
      style="background: linear-gradient(to bottom right, rgba(8,58,89,1), transparent)"
    ></div>
    
    <div class="container mx-auto px-4 relative z-10">
      <h2 class="text-white text-center text-3xl font-bold mb-12 uppercase">
        {{ t('offerSection.title') }}
        <div class="h-1 bg-red-500 w-20 mx-auto mt-2"></div>
      </h2>

      <div class="grid md:grid-cols-2 gap-8">
        <div 
          v-for="offer in offers" 
          :key="offer.title" 
          class="bg-black bg-opacity-25 rounded-lg overflow-hidden shadow-lg"
        >
          <img 
            :src="offer.image" 
            :alt="offer.title"
            class="w-full h-64 object-cover"
          />
          <div class="p-6">
            <h3 class="text-white text-xl font-semibold mb-4">{{ offer.title }}</h3>
            <p class="text-gray-300 mb-6">
              {{ offer.description }}
            </p>
            <button 
              class="bg-[#FF6816] text-white px-6 py-3 rounded-full hover:bg-[#CC530F] transition"
              @click="handleButtonClick(offer.formValue)"
            >
              {{ offer.buttonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>